import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { catchError, combineLatest, exhaustMap, filter, map, Observable, of, OperatorFunction, take, tap } from 'rxjs';
import { SubmissionFormOptions, SubmissionResult } from '../domain/submission-form';
import { FlatFormControlsForm, FlatFormGroup } from '../domain/typed-form';
import { BaseSubmissionForm } from './base-submission-form';

export class SubmissionForm<T, TResult> extends BaseSubmissionForm<T, TResult> {
  public get controls(): FlatFormControlsForm<T> {
    // SAFETY(legacy): unreviewed, pre-dates this rule.
    return this.form.controls as FlatFormControlsForm<T>;
  }

  public constructor(
    public override readonly form: FlatFormGroup<T>,
    submitOperator: OperatorFunction<T, TResult>,
    initialValue: Partial<T> | Observable<Partial<T>> = {},
    options: Partial<SubmissionFormOptions> = {},
  ) {
    super(form, submitOperator, initialValue, options);
  }

  createFormSubmissionStream(valid$: Observable<boolean>, operator: OperatorFunction<T, TResult>): Observable<SubmissionResult<TResult>> {
    return combineLatest([valid$, this.submitting$]).pipe(
      filter(([valid, submitting]) => valid && submitting),
      exhaustMap(() =>
        // SAFETY(legacy): unreviewed, pre-dates this rule.
        of(this.form.value as T).pipe(
          operator,
          map((response) => ({ type: 'success' as const, payload: response })),
          catchError((error) => {
            console.error(error);
            return of({
              type: 'error' as const,
              error: this.getServerError(error),
            });
          }),
          take(1),
        ),
      ),
      tap(({ type }) => this.setSubmissionState(type)),
      rmaShareReplay(),
    );
  }
}
